import { render } from "./Leistungen.vue?vue&type=template&id=08002308&scoped=true"
import script from "./Leistungen.vue?vue&type=script&lang=js"
export * from "./Leistungen.vue?vue&type=script&lang=js"

import "./Leistungen.vue?vue&type=style&index=0&id=08002308&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08002308"]])

export default __exports__